// extracted by mini-css-extract-plugin
module.exports = {"filled":"TitleBarIcon_filled__9XLka","icon":"TitleBarIcon_icon__2sDXH"};